/**
 * Product branding — app name, org labels, and document titles.
 *
 * Not to be confused with `appsConfig.js`, which defines launcher modules
 * (MEL, Finance, Events, etc.) and their menus/routes.
 *
 * Frontend and backend are deployed separately; keep in sync with
 * `lhrc_erp_dev_backend/src/config/brandingConfig.js`.
 */

export const APP_NAME = 'LHRC ERP';
export const APP_NAME_FULL = `${APP_NAME} System`;
export const APP_ORG_NAME = 'Legal and Human Rights Centre';
export const APP_ORG_NAME_SHORT = 'LHRC';
export const APP_ORG_URL = 'https://humanrights.or.tz/';
export const SMS_SOURCE_ADDR = APP_ORG_NAME_SHORT;

/** Build a browser tab title: "LHRC ERP | Page Name" */
export function appPageTitle(pageTitle) {
  return pageTitle ? `${APP_NAME} | ${pageTitle}` : APP_NAME;
}

/** e.g. Legal and Human Rights Centre (LHRC) */
export function orgWithShort() {
  return `${APP_ORG_NAME} (${APP_ORG_NAME_SHORT})`;
}

/** e.g. Legal and Human Rights Centre (LHRC) ERP system */
export function orgProductSystem() {
  return `${orgWithShort()} ERP system`;
}

/** e.g. LHRC Alumni — display label with org short name */
export function orgShortLabel(suffix) {
  const tail = String(suffix ?? '').trim();
  return tail ? `${APP_ORG_NAME_SHORT} ${tail}` : APP_ORG_NAME_SHORT;
}

export function copyrightNotice(year = new Date().getFullYear()) {
  return `© ${year} ${orgWithShort()}`;
}

export function smsSourceAddr() {
  return APP_ORG_NAME_SHORT;
}
